import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkCalculationitem } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-items-for-employees',
  templateUrl: './ax-project-items-for-employees.component.html',
  styleUrls: ['./ax-project-items-for-employees.component.scss'],
})
export class AxProjectItemsForEmployeesComponent implements OnInit {
  @Input() calculationitems: WorkCalculationitem[];
  @Output() openItemDetailsForCalculationitem: EventEmitter<WorkCalculationitem> = new EventEmitter<WorkCalculationitem>();
  public accordionStates: any = {};

  constructor() {
  }

  ngOnInit() {
  }
}
